import firebase from '../firebase';
/**
 * Likes of unlikes any firebase end point.
 */
const SearchSDK = {
  searchUser: (text) => {
    let userRef = firebase.database().ref('users/');
    let searchByEmail = userRef.orderByChild('email').startAt(text)
             .endAt(text+"\uf8ff")
             .once("value");
    let searchByName = userRef.orderByChild('name').startAt(text)
             .endAt(text+"\uf8ff")
             .once("value");
    let searchByContact = userRef.orderByChild('contact').startAt(text)
             .endAt(text+"\uf8ff")
             .once("value");
    return new Promise ((resolve,reject) => {
        let users = {};
        Promise.all([searchByEmail, searchByName, searchByContact]).then(resArr => {
          let searchByEmailUser =  resArr[0].val();
          let searchByNameUser = resArr[1].val();
          let searchByContactUser = resArr[2].val();
          users = {...searchByEmailUser,...searchByNameUser,...searchByContactUser}
          //console.log(users);
          resolve(users);
        }).catch(error => {
          reject(error);
        }); 
    });    
  },
};

export default SearchSDK;
